module.exports = __webpack_public_path__ + "static/img/ddzt.5cd50ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ddzt.jpg
// module id = 8oV2
// module chunks = 4